import React from "react";

const UpArrowIcon = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_2751_2924)">
            <path
                d="M12.4425 11.5575L9 8.1225L5.5575 11.5575L4.5 10.5L9 6L13.5 10.5L12.4425 11.5575Z"
                fill="currentColor"
            />
        </g>

        <defs>
            <clipPath id="clip0_2751_2924">
                <rect width="18" height="18" fill="white" transform="matrix(1 0 0 -1 0 18)" />
            </clipPath>
        </defs>
    </svg>
);

export default UpArrowIcon;
